import type { IconProps } from '../types/IconProps.ts';
export const Alert: IconProps = {
    name: 'Alert',
    children: [
        `<circle cx="12" cy="12" r="10" />`,
        `<path d="M12 8v4" />`,
        `<circle cx="12" cy="16" r=".5" />`,
    ]
};